import { PriorityPlaylist } from '@backrs_ui/common-ui';

export const getPlaylistPercentageFilled = (playlist: PriorityPlaylist): number =>
  !!playlist.completed_tasks && !!playlist.total_tasks
    ? (playlist.completed_tasks / playlist.total_tasks) * 100
    : 0;

export const handlePlaylistSearch = (
  playlists: PriorityPlaylist[],
  searchTerm: string,
): PriorityPlaylist[] => {
  if (searchTerm.length === 0) {
    return playlists;
  }

  const searchLower = searchTerm.toLowerCase();

  return playlists.filter((playlist) => {
    const searchableText = [
      playlist.title,
      playlist.description,
      playlist.marketing_description,
      playlist.keywords,
      ...(playlist.tags?.map((tag) => tag.title) ?? []),
    ]
      .join(' ')
      .toLowerCase();

    return searchableText.includes(searchLower);
  });
};
